"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRecordShiftMatchesDto = instanceOfRecordShiftMatchesDto;
exports.RecordShiftMatchesDtoFromJSON = RecordShiftMatchesDtoFromJSON;
exports.RecordShiftMatchesDtoFromJSONTyped = RecordShiftMatchesDtoFromJSONTyped;
exports.RecordShiftMatchesDtoToJSON = RecordShiftMatchesDtoToJSON;
exports.RecordShiftMatchesDtoToJSONTyped = RecordShiftMatchesDtoToJSONTyped;
/**
 * Check if a given object implements the RecordShiftMatchesDto interface.
 */
function instanceOfRecordShiftMatchesDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfileIds' in value) || value['nurseProfileIds'] === undefined)
        return false;
    return true;
}
function RecordShiftMatchesDtoFromJSON(json) {
    return RecordShiftMatchesDtoFromJSONTyped(json, false);
}
function RecordShiftMatchesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'nurseProfileIds': json['nurseProfileIds'],
    };
}
function RecordShiftMatchesDtoToJSON(json) {
    return RecordShiftMatchesDtoToJSONTyped(json, false);
}
function RecordShiftMatchesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'nurseProfileIds': value['nurseProfileIds'],
    };
}
//# sourceMappingURL=RecordShiftMatchesDto.js.map